"use client";

import { createContext, useContext, useState, useMemo } from "react";
import { setSelectedCityClient } from "@helpers/client/getSelectedCity";
import { City } from "@components/organisms/CitySelectionModal/City.types";
import { defaultCity } from "@constants/cities";



const CityContext = createContext<{
  city: City;
  setCity: (city: City) => void;
}>({ city: defaultCity, setCity: () => {} });

export function CityProvider({ children, selectedCity }: { children: React.ReactNode, selectedCity: City }) {
  const [city, setCityState] = useState<City>(selectedCity || defaultCity);

  const changeCity = (newCity: City) => {
    setSelectedCityClient({
        id: newCity?.id || defaultCity.id,
        name: newCity?.name || defaultCity.name,
        slug: newCity?.city_slug || defaultCity.city_slug,
    });
    setCityState(newCity);
  };

  const value = useMemo(() => ({ city, setCity: changeCity }), [city, changeCity]);

  return <CityContext.Provider value={value}>{children}</CityContext.Provider>;
}

export function useCity() {
  return useContext(CityContext);
}
